
import { useNavigate, useLocation } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handlePortalClick = () => {
    navigate('/portal');
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="text-lg sm:text-xl lg:text-2xl font-bold mb-3 sm:mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              DHB Group
            </div>
            <p className="text-gray-300 font-light mb-4 sm:mb-6 text-xs sm:text-sm lg:text-base leading-relaxed">
              Leading cross-border outdoor advertising agency specializing in GCC and Asian markets. Premium billboard placements and digital OOH solutions.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <a href="#" className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-sm sm:text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-sm sm:text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-sm sm:text-base"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm sm:text-base lg:text-lg font-medium mb-3 sm:mb-4 lg:mb-6">Services</h3>
            <ul className="space-y-1 sm:space-y-2 lg:space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors font-light text-xs sm:text-sm lg:text-base cursor-pointer"
                >
                  3D Immersive Displays
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors font-light text-xs sm:text-sm lg:text-base cursor-pointer"
                >
                  Highway Billboards
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors font-light text-xs sm:text-sm lg:text-base cursor-pointer"
                >
                  Airport Advertising
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors font-light text-xs sm:text-sm lg:text-base cursor-pointer"
                >
                  Digital Analytics
                </button>
              </li>
            </ul>
          </div>

          {/* Markets */}
          <div>
            <h3 className="text-sm sm:text-base lg:text-lg font-medium mb-3 sm:mb-4 lg:mb-6">Markets</h3>
            <ul className="space-y-1 sm:space-y-2 lg:space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('markets')}
                  className="text-gray-300 hover:text-white transition-colors font-light text-xs sm:text-sm lg:text-base cursor-pointer"
                >
                  Dubai & UAE
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('markets')}
                  className="text-gray-300 hover:text-white transition-colors font-light text-xs sm:text-sm lg:text-base cursor-pointer"
                >
                  Saudi Arabia
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('markets')}
                  className="text-gray-300 hover:text-white transition-colors font-light text-xs sm:text-sm lg:text-base cursor-pointer"
                >
                  Singapore
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('markets')}
                  className="text-gray-300 hover:text-white transition-colors font-light text-xs sm:text-sm lg:text-base cursor-pointer"
                >
                  Tokyo & Japan
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm sm:text-base lg:text-lg font-medium mb-3 sm:mb-4 lg:mb-6">Contact</h3>
            <ul className="space-y-1 sm:space-y-2 lg:space-y-3">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-gray-400 mr-2 mt-1 flex-shrink-0"></i>
                <div className="text-gray-300 font-light text-xs sm:text-sm lg:text-base">
                  <p>Dubai: DIFC, Gate Village 3</p>
                  <p>Seoul: Gangnam Finance Center</p>
                </div>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-gray-400 mr-2 flex-shrink-0"></i>
                <span className="text-gray-300 font-light text-xs sm:text-sm lg:text-base">+971 4 123 4567</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line text-gray-400 mr-2 flex-shrink-0"></i>
                <span className="text-gray-300 font-light text-xs sm:text-sm lg:text-base">campaigns@dhbgroup.com</span>
              </li>
              <li className="pt-1 sm:pt-2">
                <button 
                  onClick={handlePortalClick}
                  className="bg-blue-600 text-white px-3 sm:px-4 lg:px-6 py-2 sm:py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium text-xs sm:text-sm lg:text-base whitespace-nowrap cursor-pointer"
                >
                  Get Free Quote
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-6 sm:mt-8 lg:mt-12 pt-4 sm:pt-6 lg:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
            <div className="text-gray-400 font-light text-xs sm:text-sm text-center sm:text-left">
              © 2024 DHB Group. All rights reserved. Premium outdoor advertising solutions.
            </div>
            <div className="flex items-center space-x-3 sm:space-x-4 lg:space-x-6">
              <a href="#" className="text-gray-400 hover:text-white transition-colors font-light text-xs sm:text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors font-light text-xs sm:text-sm cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors font-light text-xs sm:text-sm cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
